import React from 'react';
import { LanguageProvider } from './src/context/LanguageContext';

// Mantener consistencia con gatsby-ssr.js
export const wrapRootElement = ({ element }) => {
  return <LanguageProvider>{element}</LanguageProvider>;
};

// Cargar recursos no críticos después del renderizado inicial
export const onClientEntry = () => {
  // Cargar Google Fonts de forma no bloqueante
  const loadGoogleFonts = () => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  };

  // Ejecutar después del primer renderizado
  if (typeof window !== 'undefined') {
    window.requestAnimationFrame(() => {
      loadGoogleFonts();
    });
  }
};

// Restaurar la posición del scroll al navegar
export const shouldUpdateScroll = ({
  routerProps: { location },
  prevRouterProps
}) => {
  // Si es un hash link, dejar que el navegador maneje el scroll
  if (location.hash) {
    return false;
  }

  // Si es una nueva página, scroll al top
  return true;
}; 